/**
 * MD5 for `PUT /v2/user_auth` credentials (`md5(username:password)`).
 * Web Crypto has no MD5 and SHA-1 via `crypto.subtle` needs a secure
 * context, which plain-http lab hosts are not. RFC 1321, hex output.
 */
export function md5(input: string): string {
  const bytes = new TextEncoder().encode(input);
  const len = bytes.length;
  const words = new Uint32Array(((len + 8) >>> 6) * 16 + 16);
  for (let i = 0; i < len; i++) words[i >> 2] |= bytes[i] << ((i % 4) * 8);
  words[len >> 2] |= 0x80 << ((len % 4) * 8);
  words[words.length - 2] = (len * 8) >>> 0;
  words[words.length - 1] = Math.floor((len * 8) / 0x100000000);

  let a = 0x67452301, b = 0xefcdab89, c = 0x98badcfe, d = 0x10325476;
  const S = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21];
  const K = new Uint32Array(64);
  for (let i = 0; i < 64; i++) K[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000);

  for (let i = 0; i < words.length; i += 16) {
    let [A, B, C, D] = [a, b, c, d];
    for (let j = 0; j < 64; j++) {
      let f: number, g: number;
      if (j < 16) { f = (B & C) | (~B & D); g = j; }
      else if (j < 32) { f = (D & B) | (~D & C); g = (5 * j + 1) % 16; }
      else if (j < 48) { f = B ^ C ^ D; g = (3 * j + 5) % 16; }
      else { f = C ^ (B | ~D); g = (7 * j) % 16; }
      const s = S[(j >> 4) * 4 + (j % 4)];
      const t = (A + f + K[j] + words[i + g]) >>> 0;
      A = D; D = C; C = B;
      B = (B + ((t << s) | (t >>> (32 - s)))) >>> 0;
    }
    a = (a + A) >>> 0; b = (b + B) >>> 0; c = (c + C) >>> 0; d = (d + D) >>> 0;
  }
  return [a, b, c, d].map((n) => {
    let s = "";
    for (let i = 0; i < 4; i++) s += ((n >>> (i * 8)) & 0xff).toString(16).padStart(2, "0");
    return s;
  }).join("");
}
